import { createStyles, Theme } from '@material-ui/core';

export const styles = (theme: Theme) =>
  createStyles({
    title: {
      fontSize: 20,
      fontWeight: 700,
      [theme.breakpoints.down('xs')]: {
        fontSize: 14,
        lineHeight: '18px',
        whiteSpace: 'normal',
      },
    },
    paymentTypeTitle: {
      fontSize: 36,
      fontWeight: 700,
      [theme.breakpoints.down('xs')]: {
        fontSize: 20,
      },
    },
    legalTitle: {
      fontSize: 36,
      fontWeight: 700,
      '&:hover': {
        fontSize: 36,
      },
    },
    legalDescription: {
      fontSize: 12,
      '&:hover': {
        fontSize: 12,
      },
      [theme.breakpoints.down('xs')]: {
        display: 'none',
      },
    },
    locationAmountTitle: {
      fontSize: 36,
      fontWeight: 700,
      [theme.breakpoints.down('xs')]: {
        fontSize: 20,
      },
    },
    houseHoldTitle: {
      fontSize: 36,
      fontWeight: 700,
      lineHeight: '30px',
    },
    houseHoldDescription: {
      fontSize: 12,
      fontWeight: 400,
    },
    businessChoiceTitle: {
      fontSize: 20,
      fontWeight: 700,
      marginTop: '20px',
      marginBottom: '10px',
      [theme.breakpoints.down('xs')]: {
        fontSize: 14,
        lineHeight: '18px',
        whiteSpace: 'normal',
      },
    },
    iconWrapper: {
      display: 'inline-flex',
      position: 'absolute',
      left: 150,
      [theme.breakpoints.down('sm')]: {
        left: 130,
      },
    },
    slider: {
      width: '100%',
    },
    alignTop: {
      [theme.breakpoints.down('xs')]: {
        marginBottom: 63,
        '& .btn-bottom': {
          position: 'sticky',
          bottom: 0,
          left: 0,
          right: 0,
          padding: '13px',
          backgroundColor: '#fff',
          zIndex: 2,
          margin: 0,
          '& button': {
            width: '100%',
          },
        },
      },
    },
    alignBottom: {
      [theme.breakpoints.down('xs')]: {
        bottom: 0,
        left: 13,
        right: 13,
        maxHeight: 'calc(100% - 100px)',
      },
    },
    mediumWidth: {
      maxWidth: 240,
      [theme.breakpoints.down('xs')]: {
        maxWidth: 210,
      },
    },
    legalInsuranceInputWrapper: {
      marginTop: 15,
      maxWidth: 400,
      [theme.breakpoints.down('xs')]: {
        marginTop: 0,
        maxWidth: '100%',
      },
    },
  });
